import immutableUpdate from "immutable-update";
import { removeDuplicateEANProducts } from "../../../utils";

const initialState = {
  catalogData: {},
  search: "",
  selectedMarcasProducts: null,
  selectedCategoriesProducts: null,
  categoryMarkas: null,
  productsById: null,
  productsForSearch: null,
  productsFind: null,
  popupData: null,
  findPopup: null,
  productsFiltred: null,
  brandPopups: null,
  categoryPopups: null,
  groupPopups: null,
  catalogloaded: false,

};

const reducers = {
  CATALOG_LOADED: (state, action) => {

    // Products ById
    const productsById = action.payload.data.products.reduce(
      (list, product) => {
        list[product.itf] = product;
        return list;
      },
      {}
    );

    const categoryMarkas = action.payload.data.categorias.reduce(
      (list, category) => {
        const { products } = action.payload.data;

        if (!list[category.code]) {
          list[category.code] = {};
        }

        const getProductsByMarca = products
          .filter((product) => product.categoria === category.code)
          .reduce((list, element) => {
            if (!list[element.marca]) {
              list[element.marca] = [];
            }

            list[element.marca].push(element);

            return list;
          }, {});

        Object.assign(list[category.code], getProductsByMarca);

        return list;
      },
      {}
    );

    // Product list for search
    const productsForSearch = action.payload.data.products.reduce(
      (list, product) => {
        const stringsearch = Object.keys(product).reduce((string, key) => {
          if (key === "catalogo") {
            return string;
          }

          string += (product[key] + "|").toLowerCase();
          return string;
        }, "");

        list[product.itf] = stringsearch;
        return list;
      },
      {}
    );

    return immutableUpdate(state, {
      catalogloaded: true,
      catalogData: action.payload.data,
      productsById: productsById,
      productsForSearch: productsForSearch,
      categoryMarkas: categoryMarkas,
    });
  },

  POPUP_HYDRATE: (state, action) => {

    const toObj = action.payload.data.reduce((list, item) => {

      if(item.catalogo !== "*") {

        if(!list.byCatalog[item.catalogo]) {
          list.byCatalog[item.catalogo] = {}
  
        } 

        if(!list.byCatalog[item.catalogo][item.clave]) {
          list.byCatalog[item.catalogo][item.clave] = []
        }
  
        list.byCatalog[item.catalogo][item.clave].push(item);

      } else {

        if(!list.byClave[item.clave]) {
          list.byClave[item.clave] = []
      }
        
        list.byClave[item.clave].push(item);

      }   

      return list;

    },{byCatalog:{}, byClave:{}})

    return immutableUpdate(state, {
      popupData: toObj,
    });
  },

  FIND_BRAND_POPUP: (state, action) => {
    const { brandPopups } = state;

    const { marcaId } = action.payload.data;

    const brand = Object.keys(brandPopups).reduce((list, key) => {
      if (brandPopups[marcaId]) {
        brandPopups[marcaId].type = "marca"
        list = brandPopups[marcaId];
        return list;
      } else {
        return null;
      }
    }, {});

    return immutableUpdate(
      state,
      {
        findPopup: brand,
      },
      ["findPopup"]
    );
  },

  FIND_CATEGORY_POPUP: (state, action) => {
    const { categoryPopups } = state;

    const { categoriaId } = action.payload.data;

    const category = categoryPopups && Object.keys(categoryPopups).reduce((list, key) => {
      if (categoryPopups[categoriaId]) {
        categoryPopups[categoriaId].type = "category"
        list = categoryPopups[categoriaId];
        return list;
      } else {
        return null;
      }
    }, {});

    return immutableUpdate(
      state,
      {
        findPopup: category,
      },
      ["findPopup"]
    );
  },

  SET_SEARCH_KEY: (state, action) => {


    return immutableUpdate(
          state,
          {
            search: action.payload.data,
          },
        );
  },


  // FIND_PRODUCTS: (state, action) => {
  //   const { productsForSearch, productsById } = state;
  //   const searchValue = action.payload.data;
  //   const products =
  //     searchValue === ""
  //       ? []
  //       : Object.keys(productsForSearch)
  //           .filter((key) =>
  //             productsForSearch[key].includes(searchValue.toLowerCase())
  //           ).map((key) => productsById[key])
            
            
  //    const removeDuplicateProductsSearch = [...new Map(products.map(item => [item.ean, item])).values()]       
  //                                           .sort((a, b) => a.rowindex - b.rowindex)
  //                                           .reduce((list, item, index) => {
  //                                             item.index = index;
  //                                             if (!list[item.grupo]) {
  //                                               list[item.grupo] = [];
  //                                             }
  //                                             list[item.grupo].push(item);
  //                                             return list;
  //                                           }, {});

  //   return immutableUpdate(
  //     state,
  //     {
  //       search: searchValue,
  //       productsFind: Object.keys(removeDuplicateProductsSearch).length === 0 ? [] : removeDuplicateProductsSearch,
  //     },
  //     ["productsFind"]
  //   );
  // },

  FILTER_MARCAS_PRODUCTS: (state, action) => {
    const { catalogData } = state;


    const category = action.payload.data.toLowerCase();

    let ordenProductsByCategoria =
      catalogData &&
      catalogData.products.reduce((list, item) => {
        if (!list[item.categoria]) {
          list[item.categoria] = [];
        }

        list[item.categoria].push(item);

        return list;
      }, {});


    const filterProducts = ordenProductsByCategoria[category].reduce(
      (list, item) => {
        if (!list[item.marca]) {
          list[item.marca] = [];
        }

        list[item.marca].push(item);

        return list;
      },
      {}
    );
    return immutableUpdate(
      state,
      {
        selectedMarcasProducts: filterProducts,
      },
      ["selectedMarcasProducts"]
    );
  },

  FILTER_CATEGORIAS_PRODUCTS: (state, action) => {
    const { estructura, categorias } = state.catalogData;

    const catalogoId = action.payload.data && action.payload.data.toLowerCase();

    let categories;

    if(!catalogoId) {

      categories = categorias.map(category => category.code);

    } else {

      categories = [...new Map(estructura.filter(product => product.catalogo === catalogoId).map(item => [item["categoria"], item]))].map(item => item[0]);
    }

    // let findCategoriesByCatalogId =
    //   catalogData &&
    //   catalogData.categorias.reduce((list, item) => {
    //     if (!catalogoId || (item.catalogos && item.catalogos[catalogoId])) {
    //       list[item.name] = item;
    //     }

    //     return list;
    //   }, {});

    // const odernAllCategories = catalogData.categorias.reduce((list, item) => {
    //   list[item.name] = item;
    //   return list;
    // }, {});

    // const findCategorias = Object.keys(findCategoriesByCatalogId).map((key) => {
    //   return odernAllCategories[key];
    // });

    return immutableUpdate(
      state,
      {
        selectedCategoriesProducts: categories,
      },
      ["selectedCategoriesProducts"]
    );
  },

  FILTER_PRODUCTS: (state, action) => {
    const { marcaId, catalogoId, categoriaId } = action.payload.data;
    const { products, categorias, groups } = state.catalogData;

    const groupsByCode = groups.reduce((list, item) => {
      list[item.code] = item;
      return list;

    },{})


    const categoryList =
      categorias &&
      categorias.reduce((element, list) => {
        element[list.code] = list;

        return element;
      }, {});


    const getCategoryID =
      categoryList && categoriaId && categoryList[categoriaId].code;


    let filtredProducts;

    if (catalogoId && getCategoryID && marcaId) {
      const productos =
      products &&
        products.filter((element) => {
          return (
            element.categoria === getCategoryID &&
            element.catalogo === catalogoId &&
            element.marca.toLowerCase() === marcaId.replace(/[-]/g, " ")
          );
        });

      filtredProducts =  productos
    }

    if (marcaId && getCategoryID && !catalogoId) {
      const productos =
      products &&
      products.filter(
          (element) =>
            element.categoria === getCategoryID &&
            element.marca.toLowerCase() === marcaId.replace(/[-]/g, " ")
        );

      filtredProducts = productos;
    }

    if (marcaId && !getCategoryID && !catalogoId) {
      const productos =
      products &&
      products.filter(
          (element) =>
            element.marca.toLowerCase() === marcaId.replace(/[-]/g, " ")
        );

      filtredProducts = productos;
    }
       
    const productos =
      filtredProducts &&
      [...new Map(filtredProducts.map(item => [item.ean, item])).values()].sort((a, b) => a.index - b.index)
        .reduce((list, item) => {


          if (!list[groupsByCode[item.grupo].name]) {
            list[groupsByCode[item.grupo].name] = [];
          }

          list[groupsByCode[item.grupo].name].push(item);
          return list;
        }, {});

    return immutableUpdate(
      state,
      {
        productsFiltred: productos,
      },
      ["productsFiltred"]
    );
  },
};

const reducer = (state = initialState, action) =>
  reducers[action.type] ? reducers[action.type](state, action) : state;

export default reducer;
